export default __webpack_public_path__ + "static/media/CityLights04.461b9e99.jpg";